export var primaryLink = '_21Jej';
export var primaryMinHeight = '_2KyOe';
export var primaryImage = '$KiYyV';
export var chevronIcon = 'OwUek';